<template lang="pug">
  .map-container.geo.forecasts.map-treads
    router-view
    .toolbar
      .toolbar__line
        h1.title.toolbar__title {{$translate('Моделирование')}}
        e-suggestion(
          placeholder=" "
          @selectItem="selectItemOnMapSearch"
          name="q"
          :model="suggestionMapSearch"
          :useInnerSearch="true"
          :options="suggestionMapSearchOptions"
        ).search
        div.actions-panel.display-flex
          button.reset-btn.button.button_download.button_icon.button_small(@click="getAndSaveScreenshot")
          downloadFile(
            text="KML"
            className="download-kml"
            :url="downloadKMLEndpoint"
          )
          downloadFile(
            text="Shapefile"
            className="download-shape"
            :url="downloadShapefileEndpoint"
          )
    map-mapping-legend(
      :mappingCurrentLegend="mappingCurrentLegend"
      :legendItems="legendItems"
      style="top: 60%!important; bottom: 89px;"
    )
    map-mapping-legend(
      v-if="showModelTariffs"
      :mappingCurrentLegend="{title: 'Тарифы'}"
      :legendItems="tariffLegendRegion.data ? tariffLegendRegion.data : []"
      style="left: 10px !important; bottom: 89px;"
    )
    div(v-if="yearList && yearList.length").year-track
      span.year-track__title Дата: {{year}}
      div.year-track__wrapper
        span.year-track__start {{min}}
        div.year-track__path
          el-slider(
            style="width:100%;"
            :min="min"
            :max="max"
            v-model="year"
            @change="yearHandler"
            :step="1"
            show-stops
          )
        span.year-track__end {{max}}
        button.reset-btn.button.button_edit.button_small.button_icon(
          v-if="!$store.getters.isGuest"
          @click="popUpMapShow('showMapPopup',['showMapPopupCreate', 'showMapPopupDelete'])"
        )
        button.reset-btn.button.button_add.button_small.button_icon(
          v-if="!$store.getters.isGuest"
          @click="popUpMapShow('showMapPopupCreate',['showMapPopup', 'showMapPopupDelete'])"
        )
        el-tooltip(placement="top")
          div(slot="content")
            p При обновлении потоков на схеме моделирования отобразятся объекты
            p обращения с отходами и потоки к ним, отображенные на схеме потоков
            p независимо от года
          el-button.reset-btn.button.button_delete.button_small.button_icon(
            v-if="!$store.getters.isGuest"
            @click="popUpMapShow('showMapPopupDelete',['showMapPopupCreate', 'showMapPopup'])"
          )
        el-tooltip(placement="top")
          div(slot="content")
            p Перерасчет тарифа
          el-button.reset-btn.button.button_tariff.button_small.button_icon(
            v-if="!$store.getters.isGuest"
            style="padding: 12px 8px important!;"
          )

      map-year-update(
        :openedStateVariable="this.popups.showMapPopup"
        @closeForm="popUpUpdateClose"
      )
      map-year-create(
        :showForm="this.popups.showMapPopupCreate"
        @closeForm="popUpCreateClose"
      )
      map-year-delete(
        :openedStateVariable="this.popups.showMapPopupDelete"
        @closeForm="popUpDeleteClose"
      )

    .new-map
      div(ref="map" v-once)#map.map.absolute
      map-legend(
        :showRemoved="true"
        @showAll="showAll"
        @showAllThreads="showAllThreads"
        @showModelTariffs="showModelTariffsHandle"
        @updateStatus="updateStatus"
      )
</template>

<script>
import DownloadFile from '@/app/geo/components/download-file'
import { map as mapEndpoints } from '@/api/api-endpoints'
import year from '@/utils/year'
import { forecastMixin } from './mixins/forecast-mixin'
import mappingMixin from './mixins/mapping-mixin'
import MapLegend from './components/map-forecasts-legend'
import MapYearUpdate from './components/map-year-update'
import MapYearCreate from './components/map-year-create'
import MapYearDelete from './components/map-year-delete'
import MapMappingLegend from './components/map-mapping-legend'

export default {
  name: 'forecasts',
  components: {
    MapYearUpdate,
    MapLegend,
    MapMappingLegend,
    MapYearCreate,
    MapYearDelete,
    DownloadFile,
  },
  mixins: [forecastMixin, mappingMixin],
  methods: {
    getMapTkoObjectsEndpoint(route) {
      return mapEndpoints.objectForThreads(route)
    },
    getMapModelingRegionTariff(year) {
      return mapEndpoints.mapModelingRegionTariff(year)
    },
    getThreadEndpoint(route) {
      if (!route.query.year) {
        route.query.year = year.getCurrentYear()
      }
      return mapEndpoints.threads(route)
    },
    getSettlementEndpoint(route) {
      return mapEndpoints.settlements(route)
    },
    getGarbageSourceEndpoint(route) {
      let routeChanged = Object.assign({}, route)
      if (routeChanged.query.optimizeThreads) {
        delete routeChanged.query.optimizeThreads
      }
      return mapEndpoints.garbageSources(routeChanged)
    },
    getTariffLegend() {
      return mapEndpoints.heatMapSettings(undefined, 'tariff')
    },
  },
  beforeCreate() {
    this.$store.commit('preloaderOn', true)
  },
  mounted() {
    this.selectedMappingObject = 'population'
    this.selectedMappingObjectZoom = Number.parseInt(
      this.$route.query.zoom || this.map.getZoom() * 1
    )
    const endpoint = mapEndpoints.mapLegend(
      this.selectedMappingObject,
      this.$route.query.zoom
    )
    if (endpoint) {
      this.$store
        .dispatch('updateUrlEndpoint', {
          endpoint,
          notReactive: true,
          fromCache: true,
        })
        .then(({ data }) => (this.legendItems = data.data))
    }
    this.onMappingCurrentLegend()
  },
}
</script>

<style lang="scss" scoped>
.search {
  width: auto;
}
</style>
